import axios from "axios";
import { BRAND_URL } from "../../../../../constants/config";
import { initialFilter } from "../../pages/brands/BrandsUIHelpers";

// CREATE =>  POST: add a new brand to the server
export function createBrand(brand) {
  return axios.post(BRAND_URL, brand);
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findBrands(queryParams) {
  queryParams = queryParams === undefined ? initialFilter : queryParams;
  const search_key = queryParams.search_key ? queryParams.search_key : queryParams.searchKey;
  const isFeatured = queryParams.isFeatured ?? initialFilter.isFeatured;
  const isEcom = queryParams.isEcom ?? initialFilter.isEcom;
  const toBooleanParam = (value) => ([true, "true", 1, "1"].includes(value) ? "1" : [false, "false", 0, "0"].includes(value) ? "0" : "");
  const isFeaturedParam = toBooleanParam(isFeatured);
  const isFeaturedBrandParam = toBooleanParam(isEcom);
  const sortField = queryParams.sortBy || "created_at";
  const sortOrder = queryParams.sortOrder === "asc" ? "asc" : "desc";
  const sortBy = queryParams.sort_by || `${sortField}:${sortOrder}`;
  return axios.get(
    `${BRAND_URL}/list2?search_key=${search_key || initialFilter.searchKey}&page=${
      queryParams.pageNumber || initialFilter.pageNumber
    }&is_featured=${isFeaturedParam}&is_featured_brand=${isFeaturedBrandParam}&sort_by=${sortBy}&page_size=${queryParams.pageSize || initialFilter.pageSize}`
  );
}

export function findMultipleBrands(id) {
  return axios.get(`${BRAND_URL}/list2?brand_ids=${id}`);
}

export function findOptimizeBrand(params) {
  return axios.get(`${BRAND_URL}/list2`, params);
}

// Edit Brand
export function editBrand(id, values) {
  return axios.put(`${BRAND_URL}/${id}`, { ...values });
}

export function findBrandById(id) {
  return axios.get(`${BRAND_URL}/${id}`);
}

export function deleteBrand(id) {
  return axios.delete(`${BRAND_URL}/${id}`);
}

// Export All brands
export function exportAllBrand() {
  return axios.get(`${BRAND_URL}/list?page_size=-1`);
}

export function checkExportApiStatus(ids) {
  return axios.post(`${BRAND_URL}/export`, { brand_ids: ids });
}
